module.exports = __webpack_public_path__ + "img/mainmenbuttonHEAD.a43e6467.png";